import { Box, makeStyles, Paper, Typography } from '@material-ui/core';
import CheckCircle from '@material-ui/icons/CheckCircle';
import LwtTable from 'components/@common/Table/LwtTable';
import React from 'react';
import { PrmOrganizationEngagementOverviewReportResult } from 'types/schema-generated-types';
import { getData } from './district-util';
import useCommonStyles from '../common/styles';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { ReportEntityType } from 'components/ReportsModule/types';

const Title = ({ text }: { text: string }) => (
  <Typography style={{ fontSize: 12 }}>{text}</Typography>
);

const SchoolTitleLink = ({ text, schoolId }: { text: string; schoolId: any }) => {
  const [, setQuery] = useReportQueryParams();

  const handleClick = () => {
    setQuery({ entityType: ReportEntityType.SCHOOL, entityId: schoolId }, 'pushIn');
  };

  return (
    <Typography
      component="a"
      onClick={handleClick}
      style={{
        fontSize: 12,
        display: 'flex',
        alignItems: 'center',
        color: '#006DB8',
        fontWeight: 450,
        textDecoration: 'underline',
        cursor: 'pointer'
      }}
    >
      {text}
    </Typography>
  );
};

type Keys = {
  id: number;
  school: string;
  setsLicensed: string;
  totalLicenced: string;
  active: string;
  overallCurriculumProgress: string;
  averageTime: string;
};

const getColumns = () => {
  return [
    {
      id: 'school',
      label: 'SCHOOL',
      sortKey: 'school',
      // eslint-disable-next-line react/display-name
      getValue(item: Keys) {
        return (
          <div key={`${item.id}_col_1`}>
            <SchoolTitleLink text={item.school} schoolId={item.id} />
          </div>
        );
      },
      sortable: true
    },
    {
      id: 'setsLicensed',
      label: 'SETS LICENSED',
      sortKey: 'setsLicensed',
      // eslint-disable-next-line react/display-name
      getValue(item: Keys) {
        return (
          <div key={`${item.id}_col_1`}>
            <Title text={item.setsLicensed} />
          </div>
        );
      },
      sortable: true
    },
    {
      id: 'totalLicenced',
      label: 'TOTAL LICENSED STUDENTS',
      sortKey: 'totalLicenced',
      // eslint-disable-next-line react/display-name
      getValue(item: Keys) {
        return (
          <Box display="flex" key={`${item.id}_col_1`}>
            <Title text={item.totalLicenced} />

            <CheckCircle
              fontSize="small"
              style={{ color: '#51A486', fontSize: 14, alignSelf: 'center' }}
            />
          </Box>
        );
      },
      sortable: true
    },
    {
      id: 'active',
      label: 'ACTIVE STUDENTS',
      sortKey: 'notMetSkill',
      // eslint-disable-next-line react/display-name
      getValue(item: Keys) {
        return (
          <div key={`${item.id}_col_1`}>
            <Title text={item.active} />
          </div>
        );
      },
      sortable: true
    },
    {
      id: 'overallCurriculumProgress',
      label: 'OVERALL CURRICULUM PROGRESS',
      sortKey: 'overallCurriculumProgress',
      // eslint-disable-next-line react/display-name
      getValue(item: any) {
        return (
          <div key={`${item.id}_col_1`}>
            <Title text={item.overallCurriculumProgress} />
          </div>
        );
      },
      sortable: true
    },
    {
      id: 'averageTime',
      label: 'AVERAGE TIME PER LESSON ',
      sortKey: 'averageTime',
      // eslint-disable-next-line react/display-name
      getValue(item: Keys) {
        return (
          <div key={`${item.id}_col_1`}>
            <Title text={item.averageTime} />
          </div>
        );
      },
      sortable: true
    }
  ];
};

type Props = {
  prmOrganizationEngagementOverviewReport: PrmOrganizationEngagementOverviewReportResult;
};

const Overview: React.FC<Props> = ({ prmOrganizationEngagementOverviewReport }) => {
  const commonClasses = useCommonStyles();
  const classes = useStyles();

  return (
    <Paper className={commonClasses.container}>
      <LwtTable
        data={getData(prmOrganizationEngagementOverviewReport)}
        columns={getColumns()}
        classes={{ headRow: () => classes.title }}
      />
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12
  }
}));
export default Overview;
